import { useEffect, useRef, useState } from "react";
import { MoreVertical } from "lucide-react";
import "./RowActions.css";

/* 표 줄 끝의 ⋮ 손잡이 = claude.ai 설정 창 "로컬 기기" 표 실측 (2026-10-19 지윤 지시).
   줄마다 단추 둘(수정·삭제)을 늘어놓으면 줄이 그 폭을 늘 비워 둬야 하고, 좁은 창에서
   먼저 찌그러진다. 저쪽은 32×32 ⋮ 하나를 두고 눌러서 메뉴를 편다 — 지우기는 빨강. */
export type RowAction = { label: string; onSelect: () => void; danger?: boolean; disabled?: boolean };

export function RowActions({ label, actions, disabled }: { label: string; actions: RowAction[]; disabled?: boolean }) {
  const [open, setOpen] = useState(false);
  const wrap = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const away = (event: MouseEvent) => { if (!wrap.current?.contains(event.target as Node)) setOpen(false); };
    const escape = (event: KeyboardEvent) => { if (event.key === "Escape") { event.stopPropagation(); setOpen(false); } };
    window.addEventListener("mousedown", away);
    window.addEventListener("keydown", escape, true);
    return () => { window.removeEventListener("mousedown", away); window.removeEventListener("keydown", escape, true); };
  }, [open]);

  const usable = actions.filter(action => !action.disabled);
  if (!usable.length) return null;
  return <div className="row-actions" ref={wrap}>
    <button type="button" className="row-actions-trigger" aria-haspopup="menu" aria-expanded={open}
      aria-label={`${label}에 대한 작업`} disabled={disabled}
      onClick={event => { event.stopPropagation(); setOpen(value => !value); }}>
      <MoreVertical size={16} aria-hidden="true" />
    </button>
    {open && <div className="row-actions-menu" role="menu">
      {usable.map(action => <button key={action.label} type="button" role="menuitem"
        className={action.danger ? "is-danger" : undefined}
        onClick={event => { event.stopPropagation(); setOpen(false); action.onSelect(); }}>{action.label}</button>)}
    </div>}
  </div>;
}
